export const balls = [
  {
    text: 'We’ll look into your draft research, agree on deadlines, prices and answer your questions.',
    image: 'research.svg',
  },
  {
    text: 'You receive a bill and contract, followed by payment.',
    image: 'payment.svg',
  },
  {
    text: `You can conduct
your research.`,
    image: 'conduct.svg',
  },
  {
    text: `We export the data 
of your research.`,
    image: 'export.svg',
  },
  {
    text: 'We share access to the app with you and provide instructions.',
    image: 'share.svg',
  },
];
